import DIApi from './_diApi';

class TypeOfFundObjectAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'TypeOfFunds';
}

export default new TypeOfFundObjectAPI();
